<template>
  <VueSidePanel
    v-model="isSidePanelOpen"
    transition-name="slide-left"
    width="50%"
    side="left"
    body-class="bbSidePanelBody bbSidePanelBody-Item"
    panel-color="transparent"
    :z-index="5000"
  >
    <template #default>
      <div class="px-4">
        <ItemCard
          :item="item"
          :item_type="item_type"
          :character="character"
          @add-character-item="$emit('add-character-item', $event)"
          @update-character-item="$emit('update-character-item', $event)"
          @delete-character-item="$emit('delete-character-item', $event)"
          @transfer-character-item="$emit('transfer-character-item', $event)"
          @close-item-panel="$emit('close-item-panel', $event)"
          @confirm-item-ok="$emit('confirm-item-ok', $event)"
        />
      </div>
    </template>
  </VueSidePanel>
</template>

<script>
import ItemCard from './ItemCard.vue'
import { VueSidePanel } from 'vue3-side-panel'
//---------
// scripts
//---------
export default {
  name: 'ItemSidePanel',
  emits: [
    'add-character-item',
    'update-character-item',
    'delete-character-item',
    'transfer-character-item',
    'close-item-panel',
    'confirm-item-ok',
  ],
  //------------
  // components
  //------------
  components: {
    VueSidePanel,
    ItemCard,
  },
  //-------
  // props
  //-------
  props: {
    item: {
      type: Object,
      required: false,
      default: null,
    },
    item_type: {
      type: String,
      required: false,
      default: '',
    },
    character: {
      type: Object,
      required: true,
      default: null,
    },
  },
  //------
  // data
  //------
  data() {
    return {
      isSidePanelOpen: true, // mandatory for VueSidePanel
    }
  },
  //---------
  // methods
  //---------
  methods: {},
  //---------
  // mounted
  //---------
  mounted() {},
}
</script>

<style scoped>
.vsp-overlay {
  background: #1e1e1e !important;
  opacity: 0.2 !important;
}
</style>
